export function archiveLogoSwitcher() {
  const archiveIdentity = document.querySelector('.identity--archive');

  if (!archiveIdentity) return;

  // 初期アニメーション用のクラスを追加
  archiveIdentity.classList.add('identity--init-animation');

  // 2秒後にdir-bottomクラスを追加（スクロール方向が設定されていない場合）
  setTimeout(() => {
    if (!document.body.classList.contains('is-disable-scroll-direction')) {
      document.body.classList.add('dir-bottom');
    }
  }, 2000);

  // スクロール方向の変更を監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // dir-bottomクラスの変更を検知した際に、初期アニメーションクラスを削除
        if (archiveIdentity.classList.contains('identity--init-animation')) {
          archiveIdentity.classList.remove('identity--init-animation');
        }
      }
    });
  });

  // body要素のclass属性を監視
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
}